import { IPageableResponse, IParkingModel, IResponse } from '@aggregator/core';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import {
  DashboardAverageParkingLoadModel,
  DashboardGeneralStatisticInfoModel,
  DashboardGroupedStatisticInfoModel,
  DashboardOperatorLoadStatisticModel,
  DashboardParkingLoadStatisticModel,
  DashboardParkingStatisticModel,
} from '../models/dashboard-type-info.model';
import { Observable } from 'rxjs';

export interface IPositioningModel {
  location: {
    x: number;
    y: number;
  };
  totalSpots: number;
  freeSpotsCount: number;
}
// TODO: Move to core models

@Injectable()
export class DashboardService {
  apiUrl = 'statistics';

  constructor(private service: BaseService) {}

  getGeneralStatisticInfo(
    filter?: unknown,
  ): Observable<IResponse<DashboardGeneralStatisticInfoModel[]>> {
    return this.service.get<IResponse<DashboardGeneralStatisticInfoModel[]>>(
      this.apiUrl + '/getGeneralStatisticInfo',
      filter,
    );
  }
  getGroupedStatisticInfo(
    filter?: unknown,
  ): Observable<IResponse<DashboardGroupedStatisticInfoModel[]>> {
    return this.service.get<IResponse<DashboardGroupedStatisticInfoModel[]>>(
      this.apiUrl + '/getGroupedStatisticInfo',
      filter,
    );
  }
  getParkingLoadStatistic(
    filter?: unknown,
  ): Observable<IResponse<IPageableResponse<DashboardParkingLoadStatisticModel>>> {
    return this.service.get<IResponse<IPageableResponse<DashboardParkingLoadStatisticModel>>>(
      this.apiUrl + '/getParkingLoadStatistic',
      filter,
    );
  }
  getOperatorLoadStatistic(
    filter?: unknown,
  ): Observable<IResponse<IPageableResponse<DashboardOperatorLoadStatisticModel>>> {
    return this.service.get<IResponse<IPageableResponse<DashboardOperatorLoadStatisticModel>>>(
      this.apiUrl + '/getOperatorLoadStatistic',
      filter,
    );
  }
  getAverageParkingLoad(filter?: unknown): Observable<IResponse<DashboardAverageParkingLoadModel>> {
    return this.service.get<IResponse<DashboardAverageParkingLoadModel>>(
      this.apiUrl + '/getAverageParkingLoad',
      filter,
    );
  }

  getPositioning(): Observable<IResponse<IPageableResponse<IPositioningModel>>> {
    return this.service.get('parkings/positioning?statuses=');
  }

  getFirstParking(): Observable<IResponse<IPageableResponse<IParkingModel>>> {
    return this.service.get<IResponse<IPageableResponse<IParkingModel>>>('parkings', {
      pageIndex: 1,
      pageSize: 1,
    });
  }

  getParkingStatisticById(
    parkingId: string,
    date: string,
  ): Observable<IResponse<DashboardParkingStatisticModel>> {
    return this.service.get<IResponse<DashboardParkingStatisticModel>>(
      `parking-statistics/${parkingId}/hourly`,
      {
        date,
      },
    );
  }
}
